import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

interface PromptSelectionCardProps {
  text: string;
  onClick?: () => void;

  removeable?: boolean;
  onRemove?: () => void;
  disabled?: boolean;
  selected: boolean;
}

export default function PromptSelectionCard(props: PromptSelectionCardProps) {
  return (
    <div
      className={clsx(
        'p-12 rounded-xs min-h-72 flex items-center w-328 shrink-0 @8xl:w-256',
        !props.disabled && 'hover:border-primary-500 hover:cursor-pointer',
        props.selected
          ? 'bg-primary-100 border-2 border-primary-500'
          : props.disabled
            ? 'bg-neutral-100 border-1 border-neutral-200  hover:cursor-not-allowed'
            : 'bg-white border-1 border-neutral-200'
      )}
      onClick={!props.disabled ? props.onClick : undefined}
    >
      <div className="flex items-center">
        <h2
          className={clsx(
            'leading-20 text-[16px] font-semibold',
            props.disabled ? 'text-neutral-400' : 'text-neutral-500'
          )}
        >
          {props.text}
        </h2>
      </div>
      {props.removeable && !props.disabled && (
        <button onClick={props.onRemove} className="ml-auto">
          <FontAwesomeIcon icon={faTimes} className="text-gray-500 hover:text-red-500" />
        </button>
      )}
    </div>
  );
}
